export default __webpack_public_path__ + "static/media/api-key-icon.b9d74939.svg";